import { createContext, useContext } from 'react';

export interface SidePanelInstance {
  collapseMainPanel: () => void;
  collapseSidePanel: () => void;
  expandMainPanel: () => void;
  expandSidePanel: () => void;
  isMainPanelCollapsed: () => boolean;
  isSidePanelCollapsed: () => boolean;
}

export const SidePanelInstanceContext = createContext<SidePanelInstance | null>(
  {
    collapseMainPanel: () => {},
    collapseSidePanel: () => {},
    expandMainPanel: () => {},
    expandSidePanel: () => {},
    isMainPanelCollapsed: () => false,
    isSidePanelCollapsed: () => true,
  },
);

export const useSidePanelInstance = (): SidePanelInstance | null => {
  return useContext(SidePanelInstanceContext);
};
